import qs from '@scoir/query-string'
import { isUndefined } from 'lodash'

export const getCollegeUrl = () => `${import.meta.env.BASE_URL}/discover/search`

export const getCollegeSearchURL = (params) =>
  `${getCollegeUrl()}${!isUndefined(params) ? '?' + qs.stringify(params) : ''}`
